import { Grid, TextField } from "@mui/material";
import {useCallback, useEffect, useState} from "react";
import {Article, ArticleImage, createArticle, removeArticle, Source, updateArticle} from "../repository/Article.repo";
import { HTMLEditor } from "./HtmlEditor";
import ViewBox from "./ViewBox";
import { ReactComponent as DeleteIcon } from "../assets/images/delete.svg";
import { ReactComponent as PlusIcon } from "../assets/images/plus-square.svg";
import UploadBox from "./UploadBox";
import CategorySelectBox from "./CategorySelectBox";
import {CategoryTree} from "../repository/CategoryTree.repo";
import {environment} from "../environments/environment";
import draftToHtml from "draftjs-to-html";
import {ContentState, convertToRaw, EditorState} from "draft-js";
import htmlToDraft from "html-to-draftjs";
import LanguageTab from "../LanguageTab";

type Props = {
    article: Article | undefined;
    onUpdate: () => void;
    setIsLoading: (status: boolean) => void;
    categories: CategoryTree[];
    currentParent?: number | null;
}

export function ArticleForm(props: Props) {
    const [sources, setSources] = useState<Source[]>([])
    const [description, setDescription] = useState<any>('')
    const [name, setName] = useState<string>('')
    const [author, setAuthor] = useState<string>('')
    const [images, setImages] = useState<ArticleImage[]>([]);
    const [descriptionInit, setDescriptionInit] = useState(EditorState.createEmpty());
    const [categories, setCategories] = useState<number[]>([]);
    const [tags, setTags] = useState<string>('');
    const [editingLanguage, setEditingLanguage] = useState('de');


    const [languageState, setLanguageState] = useState<any>({})


    useEffect(() => {

        if(props.currentParent !== null && props.currentParent !== undefined){
            console.log("cat selection", props.currentParent)
            onCategoryChanged([props.currentParent.toString()]);
        }else{
            setCategories([]);
        }

    }, []);

    useEffect(() => {
        const {article} = props;
        if(article === undefined){
            setSources([]);
            setDescription(EditorState.createEmpty());
            setName('');
            setAuthor('');
            setImages([]);
            setDescriptionInit(EditorState.createEmpty());
            setTags('');
            return;
        }

        const { ArticleSources, ArticleImages, Description, Name, Author, ArticleCategories, Tags, ArticleLanguage, ArticleSourceLanguage } = article;

        const contentBlock = htmlToDraft(Description);
        if (contentBlock) {
            const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
            const editorState = EditorState.createWithContent(contentState);
            setDescription(editorState.getCurrentContent());
            setDescriptionInit(editorState);
        }

        setSources(ArticleSources);

        setName(Name);
        setAuthor(Author);
        setImages(ArticleImages);

        setCategories(ArticleCategories.map(cat => cat.category_id));
        setTags(Tags);


        if(ArticleLanguage.length > 0){

            const lang = {};



            ArticleLanguage.forEach((lan:any) => {
                console.log(lan);
                const contentBlock = htmlToDraft(lan.Description);
                let stator:any = EditorState.createEmpty();
                if (contentBlock) {
                    const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
                    const eState = EditorState.createWithContent(contentState);
                    stator = eState
                }
                let findSources = [];
                if(ArticleSourceLanguage !== undefined){
                    findSources = ArticleSourceLanguage.filter((item:any) => item.lang === lan.lang);
                }
                // @ts-ignore
                lang[lan.lang] = {
                    name: lan.Name,
                    description: stator.getCurrentContent(),
                    author: lan.Author,
                    tags: lan.Tags,
                    descriptionInit: stator,
                    sources: findSources.map((item:any) => {
                        return {Url: item.Url, Number: item.Number, ID: item.ID}
                    })
                }

            })

            console.log(lang);

           setLanguageState({...lang})

        }


    }, [props, props.article]);


    const onCategoryChanged = useCallback((selected: string[]) => {

        setCategories(selected.map((s) => Number(s)));

    }, []);

    const onSourceAdd = useCallback((source: Source) => {

        if(editingLanguage === 'de'){
            setSources([...sources, source]);
        }else{

            if(languageState[editingLanguage] !== undefined){
                const sourcesPresent = languageState[editingLanguage].sources ?? []

                languageState[editingLanguage] = {...languageState[editingLanguage], sources: makeSourceIDsUnique([...sourcesPresent, source])}
            }else{
                languageState[editingLanguage] = {sources: [source]};
            }

            setLanguageState({...languageState});

        }

    }, [sources, editingLanguage, languageState]);

    const onSourceChange = useCallback((sourceList: Source[]) => {

        if(editingLanguage === 'de'){
            setSources([...sourceList]);
        }else{

            if(languageState[editingLanguage] !== undefined){
                languageState[editingLanguage] = {...languageState[editingLanguage], sources:sourceList}
            }else{
                languageState[editingLanguage] = {sources: sourceList};
            }

            setLanguageState({...languageState});

        }


    }, [editingLanguage, languageState]);

    const onUpload = useCallback((uploadList: string[]) => {

        let imageList: ArticleImage[] = [];


        uploadList.forEach((uploaded, i) => {
            imageList.push({ID: images.length + (i + 1), Url: uploaded});
        });


        setImages([...images, ...imageList]);

    }, [images]);


    const createOrUpdate = useCallback(async () => {

        const buildData = {
            sources: sources,
            images: images,
            title: name,
            description: draftToHtml(convertToRaw(description)),
            author: author,
            categories: categories,
            tags: tags
        }

        console.log(buildData);


        const languageStateKeys = Object.keys(languageState);

        const newEl = {};

        languageStateKeys.forEach((i) => {
            // @ts-ignore
            newEl[i] = {...languageState[i], description: languageState[i].description !== undefined ? draftToHtml(convertToRaw(languageState[i].description)) : ''}

        })


        props.setIsLoading(true);
        if(props.article !== undefined){
            await updateArticle(props.article.ID, buildData, newEl);
        }else{
            await createArticle(buildData, newEl);
        }
        props.setIsLoading(false);
        props.onUpdate();


    }, [author, categories, description, images, name, sources, tags, languageState]);


    const deleteArticle = useCallback(async () => {

        props.setIsLoading(true);
        if(props.article !== undefined){
            await removeArticle(props.article.ID);
        }
        props.setIsLoading(false);
        props.onUpdate();

    }, [props]);


    // const lookForChangesAndSetDescription = useCallback(() => {
    //     let descriptionData = description;
    //     let convertedData = draftToHtml(convertToRaw(description));
    //     const regex = /<sup>(.*?)<\/sup>/gi;
    //     if(sources.length > 0){
    //         const notFound: number[] = [];
    //         let matches: string[] | number[] | null = convertedData.match(regex);
    //         if(matches !== null){
    //             matches = matches.map((id: string) => {
    //                 return Number(id.replace('<sup>', '').replace('</sup>', ''));
    //             })
    //
    //             if(matches !== null){
    //                sources.forEach((item) => {
    //                    // @ts-ignore
    //                    const match = matches.findIndex((matchItem) => matchItem === item.Number);
    //                    if(match === -1){
    //                        notFound.push(item.Number);
    //                    }
    //                 });
    //             }
    //
    //
    //             console.log(notFound);
    //         }
    //     }
    //     //console.log(descriptionData);
    //     //setDescription(descriptionData);
    //
    // }, [sources, description]);

    const updateDescription = useCallback((descriptionFromEditor: any) => {

        if(editingLanguage === 'de'){
            setDescription(descriptionFromEditor.getCurrentContent())
            setDescriptionInit(descriptionFromEditor);
        }else{
            if(languageState[editingLanguage] !== undefined){
                languageState[editingLanguage] = {...languageState[editingLanguage], descriptionInit: descriptionFromEditor, description: descriptionFromEditor.getCurrentContent()}
            }else{
                languageState[editingLanguage] = {description: descriptionFromEditor.getCurrentContent(), descriptionInit: descriptionFromEditor}
                console.log(languageState[editingLanguage]);
            }


            setLanguageState({...languageState});
        }

    }, [editingLanguage, languageState])

    const sourceList: Source[] =  editingLanguage === 'de' ? sources : languageState[editingLanguage]?.sources ?? [];


    return (
        <div style={{ width: '95%', display: 'flex', color: '#000', flexDirection: 'column', overflowY: "scroll" }}>
            <ViewBox title={props.article === undefined ? 'Create Article' : 'Edit Article'} rightComponent={
                <div  style={{ display: 'flex', flexDirection: 'row' }}>
                    <div style={{ backgroundColor: 'green', height: 40, width: 120, display: 'flex', justifyContent: 'center', alignItems: 'center', color: '#fff', borderRadius: 8 }} onClick={createOrUpdate}> Speichern</div>
                    {props.article !== undefined && (<div onClick={deleteArticle} style={{ backgroundColor: 'red', height: 40, width: 120, marginLeft: 12, display: 'flex', justifyContent: 'center', alignItems: 'center', color: '#fff', borderRadius: 8 }}> Löschen</div>)}
                </div>
            }>
                <div style={{marginBottom: 20}}>
                    <LanguageTab onChange={setEditingLanguage} activeLanguage={editingLanguage} />
                </div>

                <Grid
                    container
                    spacing={2}
                    sx={{
                        minHeight: '100%',
                        width: '90%'
                    }}
                >
                    <Grid item md={4} xs={12} sm={12}>
                        <ViewBox title={''}>
                            <TextField id="outlined-basic"
                                       onChange={(e) => {
                                           if(editingLanguage === 'de'){
                                               setName(e.target.value)
                                           }else{
                                               if(languageState[editingLanguage] !== undefined){
                                                   languageState[editingLanguage] = {...languageState[editingLanguage], name: e.target.value}
                                               }else{
                                                   languageState[editingLanguage] = {name: e.target.value};
                                               }

                                               setLanguageState({...languageState});
                                           }

                                       }}
                                       key={editingLanguage + 'name'}
                                       value={editingLanguage === 'de' ? name : languageState[editingLanguage]?.name} defaultValue={editingLanguage === 'de' ? name : languageState[editingLanguage]?.name} label="Name" variant="outlined" />
                        </ViewBox>
                    </Grid>
                    <Grid item md={4} xs={12} sm={12}>
                        <ViewBox title={''}>
                            <TextField id="outlined-basic"
                                       onChange={(e) => {
                                           if(editingLanguage === 'de'){
                                               setTags(e.target.value)
                                           }else{
                                               if(languageState[editingLanguage] !== undefined){
                                                   languageState[editingLanguage] = {...languageState[editingLanguage], tags: e.target.value}
                                               }else{
                                                   languageState[editingLanguage] = {tags: e.target.value};
                                               }
                                               setLanguageState({...languageState});
                                           }
                                       }}
                                       key={editingLanguage+'tags'}
                                       value={editingLanguage === 'de' ? tags : languageState[editingLanguage]?.tags} defaultValue={editingLanguage === 'de' ? tags : languageState[editingLanguage]?.tags} label="Tags" variant="outlined" />
                        </ViewBox>
                    </Grid>
                    <Grid item md={4} xs={12} sm={12}>
                        <ViewBox title={''}>
                            <TextField id="outlined-basic"
                                       label="Autor"
                                       onChange={(e) => {
                                           if(editingLanguage === 'de'){
                                               setAuthor(e.target.value)
                                           }else{
                                               if(languageState[editingLanguage] !== undefined){
                                                   languageState[editingLanguage] = {...languageState[editingLanguage], author: e.target.value}
                                               }else{
                                                   languageState[editingLanguage] = {author: e.target.value};
                                               }
                                               setLanguageState({...languageState});
                                           }
                                       }} key={editingLanguage + 'name'} defaultValue={editingLanguage === 'de' ? author : languageState[editingLanguage]?.author} value={editingLanguage === 'de' ? author : languageState[editingLanguage]?.author} variant="outlined" />
                        </ViewBox>
                    </Grid>

                    <Grid item md={12} xs={12} sm={12}>
                        <ViewBox title="Category" rightComponent={
                            <div>
                                {categories.length > 0 && <div onClick={() => setCategories([])} style={{ backgroundColor: 'red', height: 25, width: 120, marginLeft: 12, display: 'flex', justifyContent: 'center', alignItems: 'center', color: '#fff', borderRadius: 8 }}> Deselect All</div>}
                            </div>
                        }>
                            <CategorySelectBox multiple={true} selected={categories.map((str) => str.toString())} categories={props.categories} onChange={onCategoryChanged} />
                        </ViewBox>
                    </Grid>

                    <Grid item md={12} xs={12} sm={12}>
                        <ViewBox title={'Beschreibung'}>
                            <HTMLEditor
                                sources={sourceList}
                                onSourceChange={onSourceChange}
                                onSourceAdd={onSourceAdd}
                                onChange={updateDescription}
                                value={editingLanguage === 'de' ? descriptionInit : languageState[editingLanguage]?.descriptionInit ?? EditorState.createEmpty()}
                            />
                        </ViewBox>
                    </Grid>

                    <Grid style={{ display: 'flex', alignItems: 'center' }} item md={12} xs={12} sm={12}>
                        <div>
                            Quellen (Sources)
                        </div>
                        {/* {sources.length === 0 &&
                            <div onClick={() => addSource()} style={{ marginLeft: 12, fontSize: 40, height: 30, width: 30, borderRadius: 60, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <PlusIcon />
                            </div>} */}
                    </Grid>

                    {sourceList.map(source => {
                        return (
                            <Grid style={{ display: 'flex', alignItems: 'center' }} item md={3} xs={12} sm={12}>
                                <ViewBox customClass="viewBox-custom viewBox" title={''} rightComponent={
                                    <div onClick={() => removeSource(source.ID)}> <DeleteIcon /></div>
                                }>
                                    <div>
                                        <TextField onChange={(text) => { handleSourceNameTyping(source.ID, text.target.value) }} defaultValue={source.Url} value={source.Url} id="outlined-basic" label="Link" variant="outlined" color="success" />
                                        <div style={{ height: 12, width: 12 }}></div>
                                        <TextField onChange={(text) => { handleSourceNumberTyping(source.ID, text.target.value) }} defaultValue={source.Number} value={source.Number} id="outlined-basic" label="Nummer" variant="outlined" color="success" />
                                    </div>
                                    <div style={{height: 20}} />
                                </ViewBox>
                            </Grid>
                        )
                    })
                    }
                    <Grid style={{ display: 'flex', alignItems: 'center' }} item md={3} xs={12} sm={12}>
                        <ViewBox onClick={addSource} customClass="viewBox-custom viewBox viewBox-Center" title={`${sources.length >= 1 ? 'Weitere' : ''} Quelle${sources.length >= 1 ? 'n' : ''} hinzufügen`}>
                            <div >
                                <PlusIcon />
                            </div>
                        </ViewBox>
                    </Grid>

                    <Grid style={{ display: 'flex', alignItems: 'center' }} item md={12} xs={12} sm={12}>
                        <div>
                            Images
                        </div>
                        {/* {sources.length === 0 &&
                            <div onClick={() => addSource()} style={{ marginLeft: 12, fontSize: 40, height: 30, width: 30, borderRadius: 60, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <PlusIcon />
                            </div>} */}
                    </Grid>


                    <Grid container direction="row" spacing={3}>

                        {images.map((image) => (
                            <Grid style={{ display: 'flex', alignItems: 'center' }} item md={3} xs={12} sm={12}>
                                <ViewBox customClass="viewBox-custom viewBox" title="" rightComponent={
                                    <div onClick={() => removeImage(image.ID)}> <DeleteIcon /></div>
                                }>
                                    <div>
                                        <img src={environment.backendUrl + image.Url} width={'100%'} />
                                    </div>
                                </ViewBox>
                            </Grid>
                        ))}


                        <Grid item md={3} xs={12} sm={12}>
                            <ViewBox customClass="viewBox-custom viewBox">
                                <UploadBox onUpload={onUpload} uploadKey={'Image'} url={''} inputAttrs={{accept: 'image/*'}} />
                            </ViewBox>
                        </Grid>


                    </Grid>




                </Grid>
            </ViewBox>
        </div>
    )

    function addImage(){
        const image: ArticleImage[] = [{ID: 0, Url: ''}];
        setImages(images.concat(image));
    }

    function addSource() {

        if(editingLanguage === 'de'){
            const nextSourceKey = (Math.max(...sources.map((source:any) => source.Number)) + 1);
            let stringArray: Source[] = [{ ID: sources.length + 1, Number: nextSourceKey, Url: '' }]
            setSources(makeSourceIDsUnique(sources.concat(stringArray)))
        }else{

            if(languageState[editingLanguage] !== undefined){
                const nextSourceKey = languageState[editingLanguage].sources ? (Math.max(...languageState[editingLanguage].sources.map((source:any) => source.Number)) + 1) : 1;
                let stringArray: Source = { ID: nextSourceKey + 1, Number: nextSourceKey, Url: '' }

                languageState[editingLanguage] =
                    {...languageState[editingLanguage], sources: makeSourceIDsUnique([...languageState[editingLanguage].sources, stringArray])}

            } else {
                let stringArray: Source = { ID: 1, Number: 1, Url: '' }
                 languageState[editingLanguage] = {sources: [stringArray]};
            }
            setLanguageState({...languageState});
        }


    }

    function removeImage(id: number): void{
        setImages(images.filter((image) => image.ID !== id));
    }

    function removeSource(id: number): void {

        if(editingLanguage === 'de'){
            let newSources = sources.filter(source => source.ID !== id)
            setSources(makeSourceIDsUnique(newSources))
        }else{
            languageState[editingLanguage] = {...languageState[editingLanguage], sources: [...makeSourceIDsUnique(languageState[editingLanguage].sources.filter((source:any) => source.ID !== id))]}
            setLanguageState({...languageState});
        }

    }

    function makeSourceIDsUnique(_sources: any) {
        let index = 1
        _sources.forEach((source: any) => {
            source.id = index;
            index += 1
        })
        return _sources
    }
    function handleSourceNameTyping(id: any, text: string) {

        let editedSource = sources.find(source => source.ID === id)
        let restOfSources = sources.filter(source => source.ID !== id)
        if (editedSource) {
            editedSource.Url = text
            setSources(sources.concat([]))
        }
    }
    function handleSourceNumberTyping(id: any, text: string) {

        let editedSource = sources.find(source => source.ID === id)
        let restOfSources = sources.filter(source => source.ID !== id)
        if (editedSource) {
            editedSource.Number = Number(text)
            setSources(sources.concat([]))
        }
    }


}


